import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.isDarkMode ? '#fff' : '#333'};
  transition: color 0.3s ease;
  
  &:hover {
    color: ${props => props.isDarkMode ? '#ffd700' : '#007bff'};
  }
`;

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <ToggleButton
      onClick={toggleTheme}
      isDarkMode={isDarkMode}
      aria-label="Toggle theme"
    >
      {isDarkMode ? '🌞' : '🌙'}
    </ToggleButton>
  );
};

export default ThemeToggle;
